import {
    RM_HARDWARE_TICKET,
    RM_HARDWARE_TICKET_FILTER
  } from "./type";
  
  const initalState = {
    rmHardwareTicket: {},
    rmHardwareTicketFilter: {},
  };
  
  const hardwareRmTicketReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
      case RM_HARDWARE_TICKET:
        return {
          ...state,
          rmHardwareTicket: payload,
        };
      case RM_HARDWARE_TICKET_FILTER:
        return {
          ...state,
          rmHardwareTicketFilter: payload,
        };
      default:
        return {
          ...state,
        };
    }
  };
  
  export default hardwareRmTicketReducer;
  